/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取外部会员卡集合
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<member.ClubCardRes>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/cards/outer`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
